import { CAP_APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/capApplicationsActionTypes';
import { IApplication } from '@modules/members/types/Applications.interface';

interface IAction {
    type: string;
    payload?: any;
}
export const INITIAL_STATE = {
    currentYear: '',
    capApplicationsInfo: {
        currentApplications: [],
        pastApplications: [],
        coverageYear: null,
        insideOE: false,
        insideQEP: false,
        householdCaseId: null,
        queuedApplications: [],
        userPermissionList: [],
    },
    appControllerInfo: {},
    outBoundButtonStatus: false,
};
export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_APPLICATIONS: {
            return {
                ...state,
                capApplicationsInfo: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_CONTROLLER: {
            return {
                ...state,
                appControllerInfo: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR: {
            return {
                ...state,
                currentYear: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_OUTBOUND_BUTTON_STATUS: {
            return {
                ...state,
                outBoundButtonStatus: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.UPDATE_APPLICATION_PROPERTY: {
            const payload = action.payload;
            if (
                !payload ||
                typeof payload !== 'object' ||
                !('caseNumber' in payload) ||
                !('property' in payload) ||
                !('value' in payload)
            ) {
                return state;
            }
            const { caseNumber, property, value } = payload;
            const currentApplications = ((state.capApplicationsInfo.currentApplications || []) as IApplication[]).map((app: IApplication) => {
                if (app.caseNumber === caseNumber) {
                    return { ...app, [property]: value };
                }
                return app;
            });

            return {
                ...state,
                capApplicationsInfo: {
                    ...state.capApplicationsInfo,
                    currentApplications,
                },
            };
        }
        default:
            return state;
    }
};
